import { PortModelAlignment } from '@projectstorm/react-diagrams';
import NodeTypes from '../../NodeTypes';
import DefaultNodeModel, { DefaultNodeModelOptions } from '../defaultNode/DefaultNodeModel';
import { PortModel } from '../../ports/PortModel';

export interface ActionModelOptions extends DefaultNodeModelOptions {
}

export class ActionModelData {
	messages: Array<string> = [];
}

export default class ActionNodeModel extends DefaultNodeModel {
	data: ActionModelData = new ActionModelData();

	constructor(options: ActionModelOptions = {}) {
	  super({
	    ...options,
	    type: NodeTypes.actionNode,
	  });
	  // setup an in and out port
	  this.addPort(
	    new PortModel({
	      in: true,
	      name: 'in',
	      alignment: PortModelAlignment.BOTTOM,
	    }),
	  );
	  this.addPort(
	    new PortModel({
	      in: false,
	      name: 'out',
	      alignment: PortModelAlignment.TOP,
	    }),
	  );
	}

	public setTitle(title: string) {
	  this.title = title;
	}

	serialize() {
	  return {
	    ...super.serialize(),
	  };
	}

	deserialize(event:any): void {
	  super.deserialize(event);
	}
}
